var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 16V17C19 18.2281 18.2281 19 17 19H7C5.77193 19 5 18.2281 5 17V16C5 15.4561 4.54386 15 4 15C3.45614 15 3 15.4561 3 16V17C3 19.2105 4.78947 21 7 21H17C19.2105 21 21 19.2105 21 17V16C21 15.4561 20.5439 15 20 15C19.4561 15 19 15.4561 19 16ZM7.29825 12.7018L11.2982 16.7018C11.4737 16.8947 11.7193 17 12 17C12.5439 17 13 16.5439 13 16C13 15.7193 12.8947 15.4737 12.7018 15.2982L8.70175 11.2982C8.52632 11.1053 8.2807 11 8 11C7.45614 11 7 11.4561 7 12C7 12.2807 7.10526 12.5263 7.29825 12.7018ZM12.7018 16.7018L16.7018 12.7018C16.8947 12.5263 17 12.2807 17 12C17 11.4561 16.5439 11 16 11C15.7193 11 15.4737 11.1053 15.2982 11.2982L11.2982 15.2982C11.1053 15.4737 11 15.7193 11 16C11 16.5439 11.4561 17 12 17C12.2807 17 12.5263 16.8947 12.7018 16.7018ZM13 16V4C13 3.45614 12.5439 3 12 3C11.4561 3 11 3.45614 11 4V16C11 16.5439 11.4561 17 12 17C12.5439 17 13 16.5439 13 16Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.cd551f8a.svg";
export { ForwardRef as ReactComponent };